<template>
  <v-container fluid style="height: 100%">
    <v-row align="center" justify="center" style="height: 100%">
      <v-col cols="12">
        <h1 class="text-h1 text-center">404. Pagina cautata nu exista</h1>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'not-found'
}
</script>
